<!-- One book, nothing to choose: renders nothing at all, which is every tenant until ZiG is on. -->
<div class="cv-wrap" *ngIf="asks">
  <button type="button" class="cv-btn" [class.cv-non-base]="!isBase" (click)="toggle()"
    [attr.aria-expanded]="open" aria-haspopup="listbox"
    title="Which currency this screen is showing. Nothing is converted — each book is counted on its own.">
    <i class="bi bi-currency-exchange"></i>
    <span class="cv-code">{{ book }}</span>
    <i class="bi" [class.bi-chevron-down]="!open" [class.bi-chevron-up]="open"></i>
  </button>

  <div class="cv-menu" *ngIf="open" role="listbox">
    <button type="button" class="cv-item" *ngFor="let c of choices" role="option"
      [class.is-picked]="isPicked(c)" [attr.aria-selected]="isPicked(c)" (click)="choose(c)">
      <i class="bi" [class.bi-check2]="isPicked(c)"></i>
      {{ c }}
    </button>
    <!-- Said out loud because it is the one thing an operator could get wrong about this control. -->
    <div class="cv-note">Shows that book's figures. Nothing is converted.</div>
  </div>
</div>
